var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreadjudicada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1425_165167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1425_165167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1228 16.5425C8.29689 16.4264 7.53126 16.177 6.82591 15.7942C6.12057 15.4114 5.50901 14.9262 4.99124 14.3387C4.47348 13.7512 4.06772 13.0821 3.77398 12.3313C3.48022 11.5805 3.33334 10.7827 3.33334 9.93792C3.33334 8.90059 3.54905 7.9395 3.98045 7.05465C4.41186 6.16981 5.02972 5.4035 5.83403 4.75573H3.94738V3.70312H7.71928V7.47502H6.66669V5.44128C5.93343 5.98289 5.37 6.64326 4.97638 7.42239C4.58277 8.20153 4.38596 9.04004 4.38596 9.93792C4.38596 11.327 4.83086 12.5405 5.72065 13.5783C6.61043 14.6161 7.74448 15.2474 9.1228 15.4723V16.5425ZM9.00001 12.9231L6.27802 10.1903L7.01755 9.45076L9.00001 11.4332L12.9825 7.45076L13.722 8.20108L9.00001 12.9231ZM12.2807 16.1795V12.4076H13.3333V14.4413C14.0621 13.888 14.6244 13.2236 15.0203 12.4481C15.4161 11.6725 15.6141 10.8358 15.6141 9.93792C15.6141 8.54881 15.1692 7.33535 14.2794 6.29756C13.3896 5.25978 12.2555 4.62843 10.8772 4.4035V3.33334C12.5335 3.55827 13.9125 4.28994 15.0142 5.52835C16.1158 6.76676 16.6667 8.23662 16.6667 9.93792C16.6667 10.9753 16.451 11.9375 16.0196 12.8246C15.5882 13.7117 14.9703 14.4791 14.166 15.1269H16.0526V16.1795H12.2807Z",
    fill: "#E18213"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreadjudicada);
export default __webpack_public_path__ + "static/media/preadjudicada.566224ebbe6fbb36818816c508768a35.svg";
export { ForwardRef as ReactComponent };